import angular from 'angular';
import uiRouter from 'angular-ui-router';
import readmissionsComponent from './readmissions.component';

let readmissionsModule = angular.module('readmissions', [
  uiRouter
])

.component('readmissions', readmissionsComponent);

export default readmissionsModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/readmissions/readmissions.js